import request from '@/utils/request'

export function gaojingshijianlist(query) {
  return request({
    url: '/iotdevice/record/list',
    method: 'get',
    params: query
  })
}